var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.source)?_c('div',{staticClass:"svg-icon",domProps:{"innerHTML":_vm._s(_vm.source)}}):_vm._e()}
var staticRenderFns = []
export { render, staticRenderFns }